// extracted by mini-css-extract-plugin
export default {"noDataContainer":"noData_noDataContainer__TXKH9"};